module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__background"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__social"
  }, [_c('a', {
    staticClass: "footer__facebook",
    attrs: {
      "href": _vm.props.acf.footer.facebook,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Facebook"
    }
  })], 1), _c('a', {
    staticClass: "footer__instagram",
    attrs: {
      "href": _vm.props.acf.footer.instagram,
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Instagram"
    }
  })], 1)]), _c('a', {
    staticClass: "footer__address",
    attrs: {
      "href": _vm.props.acf.footer.address_link,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "footer__address--icon"
  }, [_c('Icon', {
    attrs: {
      "name": "Location"
    }
  })], 1), _c('div', {
    staticClass: "footer__address--seperator"
  }), _c('div', {
    staticClass: "footer__address--text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer.address)
    }
  })]), _c('a', {
    staticClass: "footer__phone",
    attrs: {
      "href": _vm.props.acf.footer.phone_link
    }
  }, [_c('div', {
    staticClass: "footer__phone--icon"
  }, [_c('Icon', {
    attrs: {
      "name": "Phone"
    }
  })], 1), _c('div', {
    staticClass: "footer__phone--seperator"
  }), _c('div', {
    staticClass: "footer__phone--text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footer.phone)
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ff08a3","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 544
// module chunks = 1